export const VARIANT_OFFSET = {
  default: -12,
  default16: -12,
  default20: -12,
  default32: -8,
  contained: 4,
} as const;

export const VARIANT_PADDING = {
  default: 8,
  default16: 8,
  default20: 8,
  default32: 6,
  contained: 0,
} as const;
